import React from "react";
import { useTranslation } from "react-i18next";
import { renderWithDualBreaks } from "../utils/mobileBreaks";

export const Story = () => {
  const { t } = useTranslation();
  return (
    <section id="story" className="border-t border-[var(--rule)]">
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32">
        <p className="text-[11px] uppercase tracking-[0.4em] text-[var(--wax)] mb-6">— 05 —</p>
        <h2 className="font-display text-3xl md:text-4xl tracking-tight mb-10">{t("story.title")}</h2>
        <div className="space-y-7 text-[18px] text-[var(--ink-soft)] leading-[2]">
          <p className="whitespace-pre-line">{t("story.p1")}</p>
          <p>{renderWithDualBreaks(t("story.p2"))}</p>
        </div>
      </div>
    </section>
  );
};
